import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'
import Checkbox from 'shared/components/checkbox'
import infoProps from 'shared/prop-types/creation-metadata'
import { updateCreationTool } from 'shared/redux/creation-tool'
import fetchChannels from 'shared/redux/fetch-channels'
import { getCreationInfoFields, getUser, getUserPermissions } from 'shared/redux/reducers'
import styled from 'styled-components'
import Channels from './fields/channels'
import VideoDescription from './fields/description'
import Rating from './fields/rating'
import SourceURL from './fields/source-url'
import PrivacyAndTags from './fields/tags-and-privacy'
import VideoTitle from './fields/title'
import Username from './fields/username'
import css from './info-fields.css'

const UploadAsVideo = styled.div`
    display: flex;
    align-items: center;
    font-weight: bold;
    margin-bottom: 30px;
`
const CheckboxContainer = styled.span`
    margin-right: 10px;
`

class InfoFields extends PureComponent {
    static propTypes = {
        infoData: infoProps.isRequired,
        userPermissions: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired,
        getChannels: PropTypes.func.isRequired,
        canUploadAsVideo: PropTypes.bool.isRequired,
        gifIds: PropTypes.array.isRequired,
    }

    componentDidUpdate(prevProps) {
        const { onChange, canUploadAsVideo } = this.props

        if (prevProps.canUploadAsVideo && !canUploadAsVideo) {
            onChange({ isVideoUpload: false })
        }
    }

    componentWillMount() {
        const { user, getChannels } = this.props
        if (user.isStaff) {
            getChannels()
        }
    }

    render() {
        const { infoData, user, userPermissions, onChange, canUploadAsVideo, endpoint, gifIds } = this.props
        const {
            isPrivate,
            username,
            rating,
            sourceUrl,
            tags,
            featuredTags,
            isVideoUpload,
            videoTitle,
            videoDescription,
        } = infoData
        const canRate = isVideoUpload ? userPermissions.rate_upload_videos : userPermissions.rate
        const canAssignChannel = !isVideoUpload
        const showSuggestedTags = userPermissions.view_suggested_tags || user.isStaff
        return (
            <div className={css.container}>
                <div>
                    {canUploadAsVideo && (user.isStaff || userPermissions.upload_videos) && (
                        <>
                            <UploadAsVideo>
                                <CheckboxContainer>
                                    <Checkbox
                                        isChecked={isVideoUpload}
                                        onChange={value =>
                                            onChange({
                                                isVideoUpload: value,
                                                videoTitle: '',
                                                videoDescription: '',
                                            })
                                        }
                                    />
                                </CheckboxContainer>
                                Upload as Video
                            </UploadAsVideo>
                            {isVideoUpload && <VideoTitle value={videoTitle} onChange={onChange} />}
                            {isVideoUpload && <VideoDescription value={videoDescription} onChange={onChange} />}
                        </>
                    )}
                    <SourceURL value={sourceUrl} onChange={onChange} />
                    <PrivacyAndTags
                        tags={tags}
                        featuredTags={featuredTags}
                        showPrivacy={user.loggedIn}
                        allowFeaturedTags={user.isStaff}
                        allowMoreTags={user.isStaff}
                        showSuggestedTags={showSuggestedTags}
                        isPrivate={isPrivate}
                        onChange={onChange}
                        endpoint={endpoint}
                        gifIds={gifIds}
                        userName={username}
                    />
                    {canRate && <Rating value={rating} onChange={onChange} allowUnrated={user.isStaff} />}
                </div>
                <div>
                    {user.isStaff && <Username value={username} onChange={onChange} />}
                    {canAssignChannel && <Channels onChange={onChange} />}
                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        infoData: getCreationInfoFields(state),
        userPermissions: getUserPermissions(state),
        user: getUser(state),
    }),
    { getChannels: fetchChannels, onChange: updateCreationTool }
)(InfoFields)
